export default __webpack_public_path__ + "static/media/mint-img.aba306fb.gif";